import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { APPLICATION_DETAILS, TARIFF } from "tagTypes";

export const useTariffQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/tariff",
    query,
    tags: [TARIFF],
  });

export const useLazyTariffQuery = () => {
  const [getTariff, data] = useLazyGetQuery();
  const tariff = async (query = {}) =>
    await getTariff(
      {
        endpoint: "/tariff",
        query,
        tags: [TARIFF],
      },
      true
    ).unwrap();
  return [tariff, data];
};

export const usePostTariffMutation = () => {
  const [tariff, data] = usePostMutation();
  const addTariff = async (payload, query = {}) =>
    await tariff({
      endpoint: "/tariff",
      query,
      payload: payload || {},
      toastMessage: "Tariff added successfully",
      tags: [TARIFF],
    }).unwrap();
  return [addTariff, data];
};

export const usePutTariffMutation = () => {
  const [tariff, data] = usePutMutation();
  const updateTariff = async (payload, id, query = {}) =>
    await tariff({
      endpoint: `/tariff/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Tariff updated successfully",
      tags: [TARIFF],
    }).unwrap();
  return [updateTariff, data];
};

export const usePutUpdateTariffMutation = () => {
  const [changeTariff, data] = usePutMutation();
  const updateTariff = async (payload, query = {}) =>
    await changeTariff({
      endpoint: "application/tariff-update",
      query,
      payload: payload || {},
      toastMessage: "Tariff changed successfully",
      tags: [APPLICATION_DETAILS],
    }).unwrap();
  return [updateTariff, data];
};

export const useDeleteTariffMutation = () => {
  const [tariff, data] = useDeleteMutation();
  const deleteTariff = async (id, query = {}) =>
    await tariff({
      endpoint: `/tariff/${id}`,
      query,
      toastMessage: "Tariff deleted successully",
      tags: [TARIFF],
    }).unwrap();
  return [deleteTariff, data];
};
